import { Routes } from '@angular/router';
import { AppRoleGuardService } from '@app/auth/app-role-guard.service';
import { ForecastBaseComponent } from './forecast-base/forecast-base.component';
import { AuthConstants } from '@app/common/constants/AuthConstants';

let roles = AuthConstants.ROLES;

export const ForecastsRoutes: Routes = [
  {
    path: 'scenarios',
    component: ForecastBaseComponent,
    canActivate: [AppRoleGuardService],
    data: {
      title: 'Forecast Scenarios',
      expectedRoles: [
        roles.Admin.name,
        roles.Projects.name,
        roles.CapitalForecasting.name
      ]
    }
  }
];